import { createMuiTheme } from '@material-ui/core/styles'
// import themeScss from './global.scss'

/* Without running webpack, the scss files are not properly loaded, breaking changes are switched for tests */
export default isTest =>
  createMuiTheme({
    palette: isTest
      ? {}
      : {
        primary: {
          main: 'rgb(0, 102, 204)'
        },
        secondary: {
          main: '#444c5c'
        }
      },
    typography: {
      useNextVariants: true,
      // fontFamily: ['Trebuchet MS', 'Tahoma', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', 'sans-serif']
      fontFamily: ['DINPro-Light']
    },
    overrides: {
      MuiButton: {
        root: {
          border: 'solid 1px rgb(0, 102, 204)}',
          borderRadius: 0,
          backgroundColor: 'rgb(0, 102, 204)',
          '&:hover': {
            backgroundColor: '#444c5c'
          },
          '&$disabled': {
            color: 'rgba(0, 0, 0, 0.26)',
            backgroundColor: '#eaeaea',
            border: 'solid 1px transparent'
          },
          color: 'white'
        },
        label: {
          textTransform: 'none',
          minWidth: 0,
          fontSize: '16px',
          fontWeight: 900
        },
        textPrimary: {
          '&:hover': {
            backgroundColor: '#444c5c'
          }
        },
        outlined: {
          backgroundColor: 'transparent',
          color: 'rgb(0, 102, 204)',
          border: 'solid 1px',
          borderColor: 'rgb(0, 102, 204)'
        }
      },
      MuiIconButton: {
        root: {
          padding: '0',
          '&:hover': {
            backgroundColor: 'transparent'
          }
        }
      },
      MuiMenuItem: {
        root: {
          minHeight: '38px'
        }
      },
      MuiTypography: {
        h1: {
          // fontFamily: ['Trebuchet MS', 'Tahoma', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', 'sans-serif'],
          fontFamily: ['DINPro-Light'],
          fontSize: '26px',
          fontStyle: 'normal',
          fontVariant: 'normal',
          fontWeight: 'bold',
          color: '#111318'
        },
        h2: {
          // fontFamily: ['Trebuchet MS', 'Tahoma', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', 'sans-serif'],
          fontFamily: ['DINPro-Light'],
          fontSize: '22px',
          fontStyle: 'normal',
          fontVariant: 'normal',
          fontWeight: 'bold',
          color: '#111318'
        },
        h3: {
          // fontFamily: ['Trebuchet MS', 'Tahoma', 'Lucida Grande', 'Lucida Sans Unicode', 'Lucida Sans', 'sans-serif'],
          fontFamily: ['DINPro-Light'],
          fontSize: '18px',
          fontStyle: 'normal',
          fontVariant: 'normal',
          fontWeight: 'bold',
          color: '#111318'
        }
      },
      MuiCheckbox: {
        root: {
          color: '#444c5c',
          '&$checked': {
            color: '#444c5c'
          }
        },
        checked: {},
        colorSecondary: {
          '&$checked': {
            color: '#444c5c'
          }
        }
      },
      MuiInputBase: {
        root: {
          width: '100%',
          '&$disabled': {
            backgroundColor: '#f8f8f8'
          }
        }
      },
      MuiRadio: {
        root: {
          color: '#444c5c'
        }
      },
      MuiChip: {
        root: {
          height: '25px'
        },
        outlinedPrimary: {
          border: 'solid 1px',
          borderColor: '#aaaaaa',
          backgroundColor: 'rgba(0, 102, 204, 0.10)'
        },
        label: {
          fontSize: '12px',
          color: '#111318'
        },
        deleteIconOutlinedColorPrimary: {
          color: '#aaaaaa',
          marginRight: '1px',
          fontSize: '21px'
        }
      },
      MuiFormLabel: {
        root: {
          color: 'rgba(0, 0, 0, .7)'
        }
      },
      MuiFilledInput: {
        root: {
          backgroundColor: 'rgba(0, 102, 204, 0.10)',
          '&$focused': {
            backgroundColor: 'rgba(0, 102, 204, 0.10) !important'
          },
          '&$disabled': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
          }
        },
        underline: {
          '&:before': {
            borderBottom: 'none'
          }
        }
      }
    }
  })
